import React from 'react'

export default function DigitalDownloadTitle({ isDigitalSaleOnly }) {
    return (
        <div>* {!eval(isDigitalSaleOnly) && "Includes"} Digital Download</div>
    )
}
